import { ListSuggested } from "./list-suggested";

export default ListSuggested;
